// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_fm-0";
export var actionModalContentContainer = "_fm-1";
export var createTagButton = "_fm-2";
export var footerContainer = "_fm-7";
export var fullWidthDivider = "_fm-3";
export var hasCreateTagButton = "_fm-4";
export var noCreateTagButton = "_fm-5";
export var tagsContainer = "_fm-6";
export var tagsModalContentContainer = "_fm-8";